import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

const useAppUrl = () => {
    const isAuthenticated = useSelector((state: RootState) => state.userState.isAuthenticated);

    const getAppUrl = useCallback((url: string): string => {
        const apiUrl = process.env.REACT_APP_WEB_URL!;
        return isAuthenticated ? `${apiUrl}${url}` : `${apiUrl}/quicklogin?returnUrl=${url}`;
    }, [isAuthenticated]);

    const getAppGlobal = useCallback((url: string): string => {
        const apiUrl = process.env.REACT_APP_WEB_URL;
        return `${apiUrl}${url}`;
    }, []);

    return { getAppUrl, getAppGlobal };
};
export default useAppUrl;